import type { FC } from "react";
import { TargetGapMeter } from "@/ui/DataViz/TargetGapMeter/TargetGapMeter";
import type { HppdPostNumbers } from "@/utils/models";
import { formatHours, type OriginCopyContext } from "./requestOriginCopy";

type Props = {
	numbers: HppdPostNumbers;
	copy: OriginCopyContext;
	dataTestId: string;
};

/**
 * Hours scheduled and already posted against the hours the posting threshold needed, as the day stood just before the
 * post. Figures only ("217 h", "233 h needed"): the sentence above says what they are, and longer labels wrap in a card.
 */
export const RequestOriginHppdMeter: FC<Props> = ({ numbers, copy, dataTestId }) => {
	const { t } = copy;
	const have = formatHours(numbers.scheduled_hours + numbers.posted_hours, copy);
	const needed = formatHours(numbers.needed_hours, copy);
	return (
		<TargetGapMeter
			value={numbers.scheduled_hours + numbers.posted_hours}
			target={numbers.needed_hours}
			valueLabel={t("request.origin.meter.have", { hours: have })}
			targetLabel={t("request.origin.meter.needed", { hours: needed })}
			gapLabel={numbers.hours_short > 0 ? t("request.origin.meter.short", { hours: formatHours(numbers.hours_short, copy) }) : null}
			ariaLabel={t("request.origin.meter.aria", { have, needed })}
			dataTestId={dataTestId}
		/>
	);
};
